<template>
  <van-loading v-if="loading" color="#0094ff" />
  <div v-else class="templateSend">
    <div class="navBar">
      <NavBar v-if="sourceIsH5" :narBarTitle="$t('日程详情')" />
    </div>

    <div class="mainContent">
      <div class="mettingBoard">
        <div class="mettingTitle">{{ theme }}</div>
        <div class="mettingLine"></div>
        <div class="mettingTimeDay">{{ timeDay }}</div>
        <div class="mettingTimeLine">{{ timeLine }}</div>
        <div class="mettingState">{{ state }}</div>
        <div class="mettingDet">
          <img src="@/assets/images/people.png" alt="" />
          <div class="mettingName">
            {{ $t('发起人：') }}{{ inviteName }}
            <!-- {{ getText(infoId) }} -->
          </div>
        </div>
        <div class="mettingDet">
          <img
            class="location"
            src="@/assets/images/location_icon.png"
            alt=""
          />
          <div class="mettingName">
            {{ $t('地点：') }}{{ area || $t('暂无') }}
          </div>
        </div>
      </div>

      <div class="allPeoples">
        <div class="peoples">
          <div class="attendee">{{ $t('参会人') }}</div>
        </div>
        <div class="peoples-warp">
          <div
            v-for="(item, idx) in meetingList"
            :key="idx"
            :class="
              item.agree || item.agree == false
                ? 'peoples-box'
                : 'peoples-nobox'
            "
            :style="getStyle(item)"
          >
            <div>
              {{ item.staffName }}
            </div>
            <div v-if="item.agree || item.agree == false" class="people-status">
              <img
                src="@/assets/images/right_icon.png"
                alt=""
                v-if="item.agree"
              />
              <img
                src="@/assets/images/refuse_icon.png"
                alt=""
                v-if="!item.agree"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="agree-btn" v-if="showEditBtn && state !== $t('已结束')">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          @click="goEditPage"
          >{{ $t('编辑') }}</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { Loading, Button } from 'vant'
import Vue from 'vue'
import NavBar from '@/components/navBar'

import { queryCalendarById, queryCalendarByIdCode } from '@/services/api'
import dayjs from 'dayjs'

Vue.use(Loading)
Vue.use(Button)

export default {
  name: 'ScheduleInfo',
  components: {
    NavBar,
  },
  data() {
    return {
      loading: false,
      sourceIsH5: true,
      theme: '',
      timeDay: '',
      timeLine: '',
      state: null,
      inviteName: '',
      ifOnline: false,
      area: '',
      ifDetail: false,
      isOwner: false,
      meetingList: [],
      info: {},
      showEditBtn: false,
    }
  },
  created() {
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
  },
  methods: {
    getStyle(date) {
      let style = {}
      if (date.agree || date.agree == false) {
        style.background = '#F4F4F4'
        style.color = '#666666'
      } else if (
        !this.isTimeOut &&
        this.isOwner &&
        this.state !== this.$t('已取消')
      ) {
        style.background = '#E6F7FF'
        style.color = '#2094FF'
      } else {
        style.background = '#F4F4F4'
        style.color = '#666666'
      }
      return style
    },
    async init(id) {
      let res
      if (this.$route.query?.token && this.$route.query?.companyCode) {
        res = await queryCalendarByIdCode({ code: id })
      } else {
        res = await queryCalendarById({ id })
      }
      this.info = res
      this.theme = res?.calendarTopic
      this.timeDay = res?.calendarStartTime
        ? dayjs(res.calendarStartTime).format(this.$t('YYYY年MM月DD日'))
        : ''
      this.timeLine = res?.calendarStartTime
        ? `${dayjs(res.calendarStartTime).format('HH:mm')}--${dayjs(
            res.calendarEndTime
          ).format('HH:mm')}`
        : ''
      ;(this.inviteName = res?.calendarStaff
        ? res.noticeDetails.find((v) => v.staffId == res.calendarStaff)
            ?.staffName
        : ''),
        (this.area = res?.calendarAddress ?? this.$t('暂无'))
      this.meetingList = res?.noticeDetails ?? []
      this.getSate(res)

      // 非自己创建的或者状态为取消的日程，不能编辑，只能查看
      if (this.user.id != res?.calendarStaff || res?.state === 'cancel') {
        this.showEditBtn = false
      } else {
        this.showEditBtn = true
      }
    },
    goEditPage() {
      this.$router.push(`/createSchedule/?id=${this.info.id}`)
    },
    getSate(info) {
      if (info.state == 'cancel') {
        this.state = this.$t('已取消')
        return
      } else if (this.user.id == info.calendarStaff) {
        this.state = this.$t('已确认')
      } else {
        info?.noticeDetails.forEach((item) => {
          if (item.staffId == this.user.id) {
            !item.agree && (this.state = this.$t('未确认'))
            item.agree == true && (this.state = this.$t('已确认'))
            item.agree == false && (this.state = this.$t('已拒绝'))
          }
        })
      }

      if (dayjs().valueOf() >= dayjs(info.calendarEndTime).valueOf()) {
        this.state = this.$t('已结束')
      }
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'))
    const scheduleInfoId = this.$route.query?.id
    this.init(scheduleInfoId)
  },
}
</script>
<style lang="less" scoped>
.navBar {
  background: #ffffff;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  // border-bottom: 1px #ededed solid;
  .title {
    font-size: 17px;
    font-weight: 500;
    color: #333333;
  }
}

.templateSend {
  height: 100%;
  background: #ffffff;
  color: #666666;
  position: relative;
  .mainContent {
    padding: 7px 16px 20px;
    background: #fefffe;
  }
  .mettingBoard {
    width: 343px;
    min-height: 208px;
    padding: 16px;
    background: #f4f4f4;
    border-radius: 4px;
    margin-bottom: 20px;
    /deep/.van-field__control {
      font-size: 20px;
      font-weight: 600;
      color: #202020;
    }
    .mettingTitle {
      padding: 0 6px;
      font-size: 20px;
      font-weight: 600;
      color: #202020;
      margin-bottom: 15px;
      background: #f4f4f4;
    }
    .mettingLine {
      width: 323px;
      height: 1px;
      background: rgba(0, 0, 0, 0.1);
      margin-bottom: 8px;
    }
    .mettingTimeDay {
      padding: 0 6px;
      font-size: 12px;
      font-weight: 400;
      color: #949494;
      line-height: 16px;
      margin-bottom: 4px;
    }
    .mettingTimeLine {
      padding: 0 6px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 24px;
      margin-bottom: 13px;
    }
    .mettingState {
      padding: 2px 4px;
      display: inline-flex;
      height: 22px;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      font-weight: 400;
      color: #1890ff;
      background: #e6f7ff;
      border-radius: 2px;
      border: 1px solid #91d5ff;
      margin-left: 6px;
      margin-bottom: 11px;
    }
    .mettingDet {
      padding: 0 6px;
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
      .mettingName {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
      }
      .mettingBlue {
        font-size: 14px;
        font-weight: 400;
        color: #1377ec;
        line-height: 16px;
        width: 190px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }
    .mettingDetLast {
      padding: 0 6px;
      display: flex;
      align-items: center;
      img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
      .mettingName {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
      }
      .mettingBlue {
        font-size: 14px;
        font-weight: 400;
        color: #1377ec;
        line-height: 16px;
        width: 190px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }
  }
  .rejectBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
  }
  .refuseStyle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 166px;
    height: 44px;
    background: #ff4d4f;
    border-radius: 24px;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    line-height: 24px;
  }
  .confirmStyle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 166px;
    height: 44px;
    background: #009bff;
    border-radius: 24px;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    line-height: 24px;
  }
  .footerBox {
    width: 100%;
    margin-top: 24px;
    margin-bottom: 35px;
    padding-bottom: 30px;
    // padding-bottom: constant(safe-area-inset-bottom);
    // padding-bottom: env(safe-area-inset-bottom);
    .greyText {
      font-size: 13px;
      font-weight: 400;
      color: #aaaaaa;
      line-height: 24px;
      float: right;
      margin-left: 15px;
      display: flex;
      align-items: flex-end;
      shape-outside: inset(calc(100% - 100px) 0 0);
    }
    .twoPart {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .shortMessage {
        padding: 10px 10px;
        margin-right: 7px;
        width: 246px;
        min-height: 40px;
        background: #f9f9f9;
        border-radius: 24px;
        color: #aaaaaa;
        line-height: 24px;
        font-size: 13px;
        font-weight: 400;
        word-spacing: 2px;
      }
      .edit {
        width: 88px;
        height: 41px;
        background: #009bff;
        border-radius: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
      }
    }
    .onePart {
      width: 100%;
      .longMessage {
        padding: 10px 10px;
        width: 100%;
        min-height: 40px;
        background: #f9f9f9;
        border-radius: 24px;
        color: #aaaaaa;
        line-height: 24px;
        white-space: pre-wrap;
        word-break: break-all;
        font-size: 13px;
        font-weight: 400;
        word-spacing: 2px;
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
      }
    }
  }
  .btnBOX {
    // position: absolute;
    // left: 0;
    // bottom: 0;
    width: 100%;
    margin-top: 24px;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    .agreeBox {
      margin-top: 16px;
      margin-bottom: 23px;
      display: flex;
    }
  }

  .allPeoples {
    margin-bottom: 20px;
    .peoples-warp {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
    }
    .peoples-box {
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 64px;
      height: 32px;
      border-radius: 2px;
      // border: 1px solid #f4f4f4;
      margin-right: 8px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      padding: 0 10px 0 6px;
      margin-bottom: 12px;
    }
    .peoples-nobox {
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 64px;
      height: 32px;
      border-radius: 2px;
      // border: 1px solid #f4f4f4;
      margin-right: 8px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      padding: 0 18px;
      margin-bottom: 12px;
    }
    .people-status {
      margin-left: 7px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 14px;
        height: 14px;
      }
    }
  }
}

.peoples {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 12px;
  .tips {
    font-size: 12px;
    font-weight: 400;
    color: #aaaaab;
    line-height: 16px;
  }
  .tipsBlue {
    font-size: 12px;
    font-weight: 400;
    color: #009bff;
    line-height: 16px;
  }
}

.attendee {
  font-size: 20px;
  font-weight: 600;
  color: #202020;
  line-height: 24px;
}

.agree-btn {
  padding: 0 10px;
  margin-top: 20px;
}
</style>
